module.exports = __webpack_public_path__ + "static/media/fruits_18.0d84dec9.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_18.csv
// module id = 682
// module chunks = 0